import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { useEmbed } from '@/hooks/useEmbed';
import { BottomNav } from '@/components/mobile/BottomNav';

export function AppLayout() {
  const { isEmbed } = useEmbed();

  if (isEmbed) {
    return (
      <div className="h-screen bg-surface overflow-y-auto">
        <Outlet />
      </div>
    );
  }

  return (
    <div className="flex h-screen bg-surface">
      <Sidebar />
      <main className="flex-1 overflow-y-auto pt-14 md:pt-0 pb-16 md:pb-0">
        <Outlet />
      </main>
      <BottomNav />
    </div>
  );
}
